import { useEffect, useState } from 'react';
import { api, type JournalistRow } from '../api';

export function ManualReview() {
  const [rows, setRows] = useState<JournalistRow[]>([]);

  useEffect(() => {
    api.manualReview().then((result) => setRows(result.rows)).catch(() => setRows([]));
  }, []);

  return (
    <section className="panel split-panel">
      <div>
        <div className="section-head">
          <h2>Tier 4 queue</h2>
          <span>{rows.length} needs review</span>
        </div>
        <div className="review-list">
          {rows.map((row) => (
            <button type="button" key={row.id}>
              <strong>{row.canonical_name}</strong>
              <span>{row.primary_outlet ?? 'Unknown outlet'} · {row.nationality_code ?? 'Unknown nationality'}</span>
            </button>
          ))}
          {rows.length === 0 && <p>No profiles need manual review.</p>}
        </div>
      </div>
      <form className="editor">
        <label>
          <span>Nationality</span>
          <input placeholder="ISO alpha-2" maxLength={2} />
        </label>
        <label>
          <span>Review note</span>
          <textarea rows={8} placeholder="Internal note" />
        </label>
        <button type="button">Save review</button>
      </form>
    </section>
  );
}
